import { render, staticRenderFns } from "./TimelineText.vue?vue&type=template&id=9c1f63de&scoped=true&"
import script from "./TimelineText.vue?vue&type=script&lang=js&"
export * from "./TimelineText.vue?vue&type=script&lang=js&"
import style0 from "./TimelineText.vue?vue&type=style&index=0&id=9c1f63de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1f63de",
  null
  
)

export default component.exports